module.exports = __webpack_public_path__ + "img/shipo-icon-docking.75c4c1f0.svg";